import Model from "./Model";

export default class TimeInterval extends Model {
  id!: string;

  creativitiesCount!: number;
  detectionsCount!: number;
  radioDetectionsCount!: number;
  radioSecondsCount!: number;
  secondsCount!: number;
  timeInterval!: number;
  tvDetectionsCount!: number;
  tvSecondsCount!: number;
  grpCount?: string | number;
  audienceCount?: number;
  vodDetection?: number;
  ebiquityMin?: number;
  ebiquityMax?: number;
}
